var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrn5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1800,
    height: 150,
    viewBox: "0 0 1800 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_13346)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1800,
    height: 150,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 50 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 60 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 80 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 80 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 60 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 50 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 90 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 90 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 50 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 60 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 80 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 80 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 60 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 50 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 90 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 90 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 70 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 80 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 60 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 70 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 20 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 50 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 120 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 130 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 140 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 50 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 20 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 120 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 130 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 140 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 10 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 20 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 120 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 130 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 20 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 10 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 120 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 130 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 0 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 10 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 20 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 90 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 120 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 90 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 20 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 10 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 0 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 120 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 50 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 60 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 80 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 80 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 60 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 50 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 40 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 30 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 90 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 90 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 100 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 110 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 200 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 210 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 230 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 230 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 210 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 200 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 240 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 240 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 200 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 210 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 230 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 230 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 210 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 200 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 240 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 240 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 220 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 230 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 210 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 220 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 170 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 200 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 270 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 280 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 290 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 200 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 170 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 270 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 280 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 290 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 160 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 170 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 270 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 280 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 170 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 160 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 270 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 280 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 150 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 160 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 170 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 240 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 270 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 240 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 170 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 160 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 150 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 270 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 200 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 210 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 230 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 230 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 210 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 200 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 190 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 180 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 240 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 240 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 250 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 260 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 350 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 360 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 380 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 380 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 360 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 350 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 390 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 390 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 350 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 360 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 380 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 380 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 360 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 350 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 390 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 390 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 370 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 380 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 360 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 370 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 320 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 350 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 420 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 430 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 440 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 350 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 320 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 420 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 430 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 440 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 310 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 320 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 420 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 430 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 320 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 310 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 420 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 430 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 300 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 310 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 320 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 390 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 420 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 390 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 320 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 310 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 300 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 420 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 350 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 360 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 380 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 380 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 360 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 350 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 340 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 330 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 390 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 390 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 400 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 410 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 500 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 510 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 530 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 530 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 510 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 500 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 540 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 540 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 500 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 510 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 530 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 530 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 510 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 500 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 540 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 540 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 520 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 530 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 510 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 520 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 470 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 500 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 570 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 580 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 590 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 500 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 470 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 570 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 580 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 590 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 460 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 470 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 570 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 580 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 470 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 460 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 570 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 580 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 450 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 460 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 470 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 540 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 570 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 540 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 470 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 460 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 450 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 570 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 500 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 510 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 530 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 530 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 510 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 500 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 490 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 480 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 540 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 540 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 550 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 560 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 650 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 660 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 680 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 680 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 660 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 650 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 690 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 690 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 650 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 660 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 680 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 680 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 660 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 650 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 690 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 690 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 670 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 680 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 660 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 670 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 620 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 650 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 720 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 730 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 740 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 650 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 620 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 720 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 730 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 740 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 610 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 620 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 720 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 730 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 620 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 610 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 720 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 730 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 600 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 610 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 620 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 690 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 720 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 690 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 620 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 610 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 600 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 720 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 650 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 660 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 680 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 680 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 660 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 650 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 640 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 630 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 690 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 690 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 700 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 710 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1250 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1260 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1280 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1280 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1260 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1250 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1290 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1290 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1250 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1260 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1280 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1280 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1260 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1250 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1290 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1290 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1270,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1270 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1280 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1260 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1270,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1270 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1220 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1250 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1320 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1330,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1330 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1340,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1340 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1250 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1220 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1320 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1330,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1330 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1340,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1340 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1210,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1210 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1220 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1320 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1330,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1330 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1220 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1210,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1210 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1320 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1330,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1330 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1200 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1210,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1210 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1220 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1290 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1320 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1290 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1220,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1220 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1210,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1210 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1200 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1320,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1320 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1250 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1260 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1280 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1280,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1280 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1260 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1250 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1240 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1230 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1290 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1290 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1300 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1310 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 800 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 810 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 830 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 830 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 810 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 800 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 840 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 840 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 800 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 810 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 830 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 830 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 810 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 800 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 840 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 840 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 820,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 820 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 830 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 810 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 820,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 820 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 770 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 800 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 870 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 880 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 890 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 800 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 770 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 870 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 880 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 890 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 760 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 770 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 870 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 880 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 770 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 760 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 870 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 880 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 750 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 760 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 770 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 840 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 870 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 840 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 770 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 760 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 750 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 870 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 800 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 810 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 830 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 830 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 810 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 800 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 790 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 780 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 840 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 840 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 850 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 860 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1400 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1410,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1410 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1430 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1430 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1410,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1410 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1400 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1440 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1440 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1400 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1410,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1410 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1430 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1430 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1410,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1410 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1400 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1440 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1440 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1420,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1420 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1430 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1410,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1410 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1420,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1420 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1370,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1370 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1400 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1470,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1470 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1480 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1490,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1490 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1400 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1370,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1370 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1470,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1470 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1480 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1490,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1490 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1360 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1370,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1370 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1470,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1470 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1480 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1370,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1370 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1360 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1470,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1470 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1480,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1480 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1350 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1360 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1370,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1370 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1440 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1470,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1470 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1440 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1370,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1370 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1360,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1360 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1350 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1470,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1470 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1400 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1410,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1410 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1430 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1430,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1430 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1410,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1410 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1400,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1400 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1390 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1380 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1440 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1440 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1450,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1450 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1460,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1460 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 950 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 960 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 980 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 980 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 960 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 950 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 990 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 990 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 950 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 960 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 980 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 980 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 960 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 950 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 990 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 990 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 970,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 970 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 980 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 960 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 970,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 970 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 920 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 950 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1020 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1030 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1040 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 950 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 920 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1020 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1030 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1040 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 910 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 920 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1020 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1030 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 920 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 910 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1020 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1030,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1030 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 900 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 910 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 920 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 990 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1020 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 990 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 920 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 910 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 900 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1020 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 950 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 960 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 980 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 980 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 960 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 950 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 940 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 930 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 990 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 990 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1000 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1010 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1550,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1550 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1560 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1580,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1580 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1580,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1580 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1560 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1550,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1550 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1590 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1590 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1550,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1550 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1560 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1580,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1580 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1580,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1580 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1560 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1550,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1550 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1590 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1590 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1570 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1580,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1580 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1560 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1570,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1570 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1520,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1520 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1550,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1550 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1620 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1630,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1630 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1640,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1640 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1550,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1550 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1520,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1520 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1620 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1630,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1630 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1640,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1640 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1510,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1510 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1520,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1520 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1620 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1630,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1630 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1520,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1520 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1510,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1510 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1620 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1630,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1630 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1500 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1510,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1510 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1520,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1520 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1590 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1620 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1590 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1520,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1520 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1510,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1510 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1500 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1620 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1550,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1550 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1560 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1580,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1580 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1580,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1580 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1560 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1550,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1550 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1540 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1530 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1590 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1590,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1590 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1600,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1600 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1610,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1610 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1100 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1110 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1130 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1130 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1110 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1100 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1140 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1140 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1100 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1110 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1130 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1130 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1110 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1100 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1140 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1140 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1120 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1130 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1110 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1120 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1070 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1100 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1170 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1180 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1190 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1100 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1070 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1170 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1180 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1190,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1190 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1060 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1070 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1170 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1180 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1070 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1060 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1170 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1180 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1050 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1060 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1070 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1140 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1170 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1140 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1070 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1060 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1050 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1170 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1100 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1110 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1130 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1130 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1110 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1100 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1090 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1080 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1140 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1140,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1140 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1150 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1160,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1160 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1700 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1710 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1730,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1730 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1730,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1730 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1710 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1700 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1740,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1740 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1740,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1740 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1700 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1710 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1730,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1730 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1730,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1730 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1710 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1700 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1740,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1740 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 140,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 140)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 150,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 150)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1740,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1740 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1720 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1730,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1730 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710,
    y: 80,
    width: 10,
    height: 10,
    transform: "rotate(-90 1710 80)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1720 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1670 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1700 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1770,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1770 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1780,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1780 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1790,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1790 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1700 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1670 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1770,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1770 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1780,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1780 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1790,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1790 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1660,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1660 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1670 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1770,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1770 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1780,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1780 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1670 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1660,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1660 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1770,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1770 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1780,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1780 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1650 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1660,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1660 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1670 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1740,
    y: 70,
    width: 10,
    height: 10,
    transform: "rotate(-90 1740 70)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 60,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 60)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 50,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 50)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1770,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1770 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1740,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1740 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 90,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 90)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1670,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1670 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1660,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1660 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1650,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1650 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1770,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1770 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 10)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1700 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1710 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1730,
    y: 40,
    width: 10,
    height: 10,
    transform: "rotate(-90 1730 40)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1730,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1730 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710,
    y: 100,
    width: 10,
    height: 10,
    transform: "rotate(-90 1710 100)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1700 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1690,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1690 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1680 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1740,
    y: 110,
    width: 10,
    height: 10,
    transform: "rotate(-90 1740 110)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 120,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 120)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 130,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 130)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1740,
    y: 30,
    width: 10,
    height: 10,
    transform: "rotate(-90 1740 30)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1750,
    y: 20,
    width: 10,
    height: 10,
    transform: "rotate(-90 1750 20)",
    fill: "#F0C469"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 10,
    width: 10,
    height: 10,
    transform: "rotate(-90 1760 10)",
    fill: "#F0C469"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_13346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1800,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrn5);
export default __webpack_public_path__ + "static/media/orn5.db3f621972ac98ce0820838851b2ea6f.svg";
export { ForwardRef as ReactComponent };